import i18n from 'i18next';
import { Trans, useTranslation } from 'react-i18next';
import step1Img from '../../../../assets/icons/christmas-explanation-1.svg';
import step2Img from '../../../../assets/icons/christmas-explanation-2.svg';
import step3Img from '../../../../assets/icons/christmas-explanation-3.svg';
import step4Img from '../../../../assets/icons/christmas-explanation-4.svg';
import separatorImg from '../../../../assets/icons/christmas-explanation-separator.svg';
import styles from './ChristmasExplanation.module.scss';

const ChristmasExplanation = () => {
    const { t } = useTranslation();

    const steps = [
        {
            number: 1,
            image: step1Img,
            imageWidth: 70,
            imageAspectRatio: '90 / 83',
            name: t('christmasExplanation1'),
            description: i18n.t('christmasExplanationDesc1'),
            side: 'right',
        },
        {
            number: 2,
            image: step2Img,
            imageWidth: 80,
            imageAspectRatio: '1 / 1',
            name: t('christmasExplanation2'),
            description: i18n.t('christmasExplanationDesc2Part1'),
            descriptionPart2: i18n.t('christmasExplanationDesc2Part2'),
            side: 'left',
        },
        {
            number: 3,
            image: step3Img,
            imageWidth: 90,
            imageAspectRatio: '106 / 89',
            name: t('christmasExplanation3'),
            description: i18n.t('christmasExplanationDesc3Part1'),
            descriptionPart2: i18n.t('christmasExplanationDesc3Part2'),
            side: 'right',
        },
        {
            number: 4,
            image: step4Img,
            imageWidth: 85,
            imageAspectRatio: '106 / 89',
            name: t('christmasExplanation4'),
            description: i18n.t('christmasExplanationDesc4'),
            side: 'left',
        },
    ];

    return (
        <section className={styles.sectionContainer}>
            <div className={styles.whiteBackground} />
            <h2 className={styles.sectionTitle}>
                <Trans i18nKey="christmasExplanationTitle">
                    What Wonders Await <span>Christmas Markets Surprise Destination?</span>
                </Trans>
            </h2>
            <div className={styles.stepsContainer}>
                {steps.map((step) => (
                    <div className={styles.step} key={step.number}>
                        {step.side === 'left' ? (
                            <div className={styles.stepContent}>
                                <p className={styles.stepNameLeft}>{step.name}</p>
                                <p className={styles.stepDescriptionLeft}>{step.description}</p>
                                {step.descriptionPart2 && (
                                    <p className={styles.stepDescriptionLeft}>{step.descriptionPart2}</p>
                                )}
                            </div>
                        ) : (
                            <div className={styles.stepContentHidden}>
                                <p className={styles.stepNameRight}>{step.name}</p>
                                <p className={styles.stepDescriptionRight}>{step.description}</p>
                                {step.descriptionPart2 && (
                                    <p className={styles.stepDescriptionRight}>{step.descriptionPart2}</p>
                                )}
                            </div>
                        )}

                        <div className={styles.imageContainer}>
                            <div className={styles.stepImage}>
                                <img
                                    src={step.image}
                                    style={{ width: step.imageWidth, aspectRatio: step.imageAspectRatio }}
                                    alt=""
                                />
                            </div>
                            <div className={styles.step}>
                                <img
                                    src={separatorImg}
                                    className={styles.separatorImg}
                                    style={{ width: 90, aspectRatio: 1 / 1 }}
                                    alt=""
                                />
                            </div>
                        </div>

                        {step.side === 'right' ? (
                            <div className={styles.stepContent}>
                                <p className={styles.stepNameRight}>{step.name}</p>
                                <p className={styles.stepDescriptionRight}>{step.description}</p>
                                {step.descriptionPart2 && (
                                    <p className={styles.stepDescriptionRight}>{step.descriptionPart2}</p>
                                )}
                            </div>
                        ) : (
                            <div className={styles.stepContentHidden}>
                                <p className={styles.stepNameLeft}>{step.name}</p>
                                <p className={styles.stepDescriptionLeft}>{step.description}</p>
                                {step.descriptionPart2 && (
                                    <p className={styles.stepDescriptionLeft}>{step.descriptionPart2}</p>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ChristmasExplanation;
